import { LocationProfile } from 'src/app/core/models/admin';

export const FORM_CONTROL_VALUES = {
  COMPANY_NAME: 'customername',
  ADDRESS: 'streetname',
  ADDRESS_2: 'streetname2',
  STATE: 'pd1',
  CITY: 'pd2',
  POSTAL_CODE: 'postalCode',
  COUNTRY: 'isoCode',
  CURRENCY: 'currency',
  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',
  CONTACT_NAME: 'primaryName',
  CONTACT_NAME_2: 'secondaryName',
  CONTACT_EMAIL: 'primaryEmail',
  CONTACT_EMAIL_2: 'secondaryEmail',
  CONTACT_PHONE: 'primaryPhone',
  CONTACT_PHONE_2: 'secondaryPhone',
};

export const MOCK_COUNTRY_DATA = [
  {
    isoCode: '1',
    postalPattern: 'Test',
    defaultCurrency: 'Test',
    polDivOne: 'Test',
    polDivThree: 'Test',
    postalCode: 'Test',
  },
  {
    isoCode: 'US',
    postalPattern: '^[A-Z0-9]{1,6}$',
    defaultCurrency: 'USD',
    isoNumCode: '840',
    polDivOne: 'ALLOWED',
    polDivThree: 'ALLOWED',
    postalCode: 'REQUIRED',
  },
  {
    isoCode: 'AQ',
    postalPattern: '^[A-Z0-9]{1,6}$',
    defaultCurrency: 'XXX',
    isoNumCode: '010',
    polDivOne: 'ALLOWED',
    polDivThree: 'ALLOWED',
    postalCode: 'ALLOWED',
  },
  {
    isoCode: 'AX',
    postalPattern: '^[A-Z0-9]{1,6}$',
    defaultCurrency: 'EUR',
    isoNumCode: '248',
    polDivOne: 'ALLOWED',
    polDivThree: 'ALLOWED',
    postalCode: 'ALLOWED',
  },
];

export interface ContryDropdownOption {
  label: string;
  value: string;
}

export type AddressFormCopy = typeof FORM_CONTROL_VALUES | LocationProfile;

export type LocationPropertiesType = {
  currency: string;
  latitude: string;
  longitude: string;
  primaryEmail: string;
  primaryName: string;
  primaryPhone: string;
  secondaryEmail: string;
  secondaryName: string;
  secondaryPhone: string;
};

export type AddressPropertiesType = {
  customername: string;
  streetnumber: string;
  streetname: string;
  streetname2: string;
  streetprefix: string;
  streetsuffix: string;
  streettype: string;
  floor: string;
  suite: string;
  pd1: string;
  pd2: string;
  pd3: string;
  postalcode: string;
  isoCode: string;
};
